export const CASHFLOW_REPORTING = {
  relative: 'cashflow',
  path: '/portal/reports/cashflow',
}
